<template>
  <v-collapse
    ref="collapse"
    expanded
  >
    <p
      v-if="fullInfo"
      class="u-mb-15"
    >
      {{ expanded ? fullInfo : shortInfo }}
    </p>
    <details-meta
      v-if="expanded"
      :product="product"
      class="u-mb-15"
    ></details-meta>
    <span
      v-if="isExpandable"
      v-accessibility-focus="toggle"
      class="o-typography--toggle o-typography--underline u-lowercase"
      data-nosnippet
    >
      {{ expanded ? $t('glossary.less') : $t('glossary.readMore') }}
    </span>
  </v-collapse>
</template>
<script>
  import { VCollapse } from '@/index/shared/components';
  import { truncate } from '@/index/shared/filters';
  import DetailsMeta from './meta.vue';

  export default {
    components: {
      VCollapse,
      DetailsMeta,
    },
    filters: {
      truncate,
    },
    props: {
      product: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        expanded: false,
      };
    },
    computed: {
      isExpandable() {
        const metadataKeys = ['genres', 'actors', 'directors', 'audioLanguages', 'subtitles'];
        return this.fullInfo.length > this.shortInfo.length || metadataKeys.some((key) => this.product[key]?.length);
      },
      isMobile() {
        return this.$window.isMobileView;
      },
      fullInfo() {
        return this.product.description || this.product.lead || '';
      },
      shortInfo() {
        return truncate(this.fullInfo);
      },
    },
    watch: {
      product() {
        this.expanded = false;
        this.$refs.collapse.refreshHeight();
      },
    },
    methods: {
      toggle() {
        this.expanded = !this.expanded;
        this.$refs.collapse.refreshHeight();
      },
    },
  };
</script>
